var indexOf = [].indexOf;

angular.module('shared').factory('FeatureAvailabilityService', ["$rootScope", "$modal", function($rootScope, $modal) {
  return {
    isAvailable: function(feature) {
      var ref;
      return ((ref = $rootScope.gym) != null ? ref.features_enabled : void 0) && indexOf.call($rootScope.gym.features_enabled, feature) >= 0;
    },
    showNotAvailableMessage: function(feature) {
      return $modal.open({
        template: require('templates/gyms/subscriptions/feature_not_available_modal.html.slim'),
        resolve: {
          feature: function() {
            return feature;
          }
        },
        controller: ["$scope", "$modalInstance", "feature", function($scope, $modalInstance, feature) {
          $scope.isPayor = window.currentUser.account_owner;
          $scope.feature = feature;
          return $scope.close = function() {
            return $modalInstance.dismiss('cancel');
          };
        }]
      });
    }
  };
}]);
